export default __webpack_public_path__ + "static/media/third.5a314714.jpg";